import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import Decimal from 'decimal.js';
import { PriceIncreaseModel } from '../PriceIncreaseModel';
import { ServiceCostType } from './model';
export function makeFixedCost(price) {
    let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _opts_discount, _opts_discount1;
    var _opts_discount_expiration, _opts_discount2;
    const isDiscountExpired = (_opts_discount2 = opts.discount) === null || _opts_discount2 === void 0 ? void 0 : (_opts_discount_expiration = _opts_discount2.expiration()) === null || _opts_discount_expiration === void 0 ? void 0 : _opts_discount_expiration.isExpired();
    return {
        pricingType: ServiceCostType.Fixed,
        price: new Decimal(price),
        discount: isDiscountExpired ? null : (_opts_discount = opts.discount) !== null && _opts_discount !== void 0 ? _opts_discount : null,
        priceIncrease: opts.priceIncrease || PriceIncreaseModel.makeNone(),
        expiredDiscount: isDiscountExpired ? (_opts_discount1 = opts.discount) !== null && _opts_discount1 !== void 0 ? _opts_discount1 : null : null
    };
}
export function makeVariableCost(price) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _discount_expiration;
    const { unitCap, unitName, preapprovedControlledByAdvancedSettings, discount, priceIncrease } = options;
    const isDiscountExpired = discount === null || discount === void 0 ? void 0 : (_discount_expiration = discount.expiration()) === null || _discount_expiration === void 0 ? void 0 : _discount_expiration.isExpired();
    return _object_spread({
        pricingType: ServiceCostType.Variable,
        price: new Decimal(price),
        unitCap: unitCap != null ? new Decimal(unitCap) : null,
        unitName: unitName || null,
        discount: isDiscountExpired ? null : discount !== null && discount !== void 0 ? discount : null,
        priceIncrease: priceIncrease || PriceIncreaseModel.makeNone(),
        expiredDiscount: isDiscountExpired ? discount !== null && discount !== void 0 ? discount : null : null
    }, typeof preapprovedControlledByAdvancedSettings === 'boolean' && {
        preapprovedControlledByAdvancedSettings
    });
}
export function makeRangeCost(maxPrice) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _discount_expiration;
    const { minPrice, discount, priceIncrease } = options;
    const isDiscountExpired = discount === null || discount === void 0 ? void 0 : (_discount_expiration = discount.expiration()) === null || _discount_expiration === void 0 ? void 0 : _discount_expiration.isExpired();
    return {
        pricingType: ServiceCostType.Range,
        maxPrice: new Decimal(maxPrice),
        minPrice: minPrice != null ? new Decimal(minPrice) : null,
        discount: isDiscountExpired ? null : discount !== null && discount !== void 0 ? discount : null,
        priceIncrease: priceIncrease || PriceIncreaseModel.makeNone(),
        expiredDiscount: isDiscountExpired ? discount !== null && discount !== void 0 ? discount : null : null
    };
}
